import React, { FC, ReactNode } from "react";

const ListPanel: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <div
      style={{
        zIndex: 1000,
        position: "absolute",
        right: 0,
        top: 70,
        height: "100%",
        overflowY: "auto",
        backgroundColor: "rgba(255,255,255,0.9)",
        paddingBottom: 150,
        WebkitOverflowScrolling: "touch",
      }}
    >
      {children}
    </div>
  );
};

export default ListPanel;
